import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar/Sidebar";

const PublicLayout = () => (
  <Sidebar>
    <Outlet />
  </Sidebar>
);

export default PublicLayout;
